// Import models.
import BuildingResponseCommercialExisting from './BuildingResponseCommercialExisting';
import {
	BuildingStatusInfo,
} from '@app/models/api';

export default class BuildingResponseCommercialExistingWithStatus extends BuildingResponseCommercialExisting {

	public status: BuildingStatusInfo | null = null;

	public constructor() {
		super();
	}
}